import { EscalationType, PropertyInterest, ZoningCompliance } from '@aloft/toolkit-shared';

import { STOP_AND_CALL_FIELD_NAME } from './consts.ts';

export const getAPIEscalationType = (
  fieldName: STOP_AND_CALL_FIELD_NAME,
  value: any,
): EscalationType => {
  switch (fieldName) {
    case 'propertyInterest':
      if ((value as PropertyInterest) === 'Leased Fee') return 'leased_fee_property_interest';
      if ((value as PropertyInterest) === 'Leasehold') return 'leasehold_property_interest';
      break;
    case 'zoningCompliance':
      if ((value as ZoningCompliance) === 'Illegal') return 'zoning_compliance_illegal';
      break;
    case 'uadCondition':
      if (value === 5) return 'c5_condition';
      if (value === 6) return 'c6_condition';
      break;
    case 'valueTypes':
      return 'value_subject_to';
    case 'parcelNumber':
      return 'parcel_number_unavailable';
    default:
      break;
  }

  return 'value_subject_to';
};
